
//Here we can have the token to autenticate with backend from node js

const token = localStorage.getItem('userData') ? localStorage.getItem('userData').replace(/"/g, '') : null;

const headers = {
  headers: {
    Authorization: `Bearer ${token}`
  }
};
  
module.exports = {
    headers 
}